"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Promo = /*#__PURE__*/function () {
  function Promo(client) {
    (0, _classCallCheck2["default"])(this, Promo);
    this.client = client;
    this.resourceUrl = '/promo';
  }

  (0, _createClass2["default"])(Promo, [{
    key: "getPromoCodeList",
    value: function getPromoCodeList() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl), args);
    }
  }, {
    key: "createPromoCode",
    value: function createPromoCode(data) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return this.client.post("".concat(this.resourceUrl), data, args);
    }
  }, {
    key: "deletePromoCode",
    value: function deletePromoCode(promoId) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.client["delete"]("".concat(this.resourceUrl, "/").concat(promoId), args);
    }
  }, {
    key: "getPromData",
    value: function getPromData(promoId) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(promoId), args);
    }
  }, {
    key: "updatePromoCode",
    value: function updatePromoCode(promoId, data) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return this.client.put("".concat(this.resourceUrl, "/").concat(promoId), data, args);
    }
  }, {
    key: "getActivePromoCodeList",
    value: function getActivePromoCodeList() {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return this.client.get("".concat(this.resourceUrl, "/active-promos"), args);
    }
  }]);
  return Promo;
}();

exports["default"] = Promo;